export default function CountdownOverlay({ countdownNum }) {
  if (countdownNum === null) return null;
  return (
    <div className="rhythm-countdown" aria-live="off">
      <p>Escucha el pulso</p>
      <strong key={countdownNum}>{countdownNum}</strong>
      <span>Cuatro tiempos. Entra con la música.</span>
    </div>
  );
}
